<template>
<div class="shopping-cart--register">
    <div class="row">
        <div class="col-12 text-center" v-html="$t('cart.register.top_text')"></div>
    </div>
    <div class="row justify-content-center">
        <div class="col-md-3 col-sm-6">
            <button
                type="button"
                :class="personBtnClassList"
                @click.prevent="userType = 1"
            >{{$t('auth.register.form.btns.person')}}</button>
        </div>
        <div class="col-md-3 col-sm-6">
            <button
                type="button"
                :class="companyBtnClassList"
                @click.prevent="userType = 2"
            >{{$t('auth.register.form.btns.company')}}</button>
        </div>
    </div>
    <form class="form-horizontal" method="POST" action="">
        <div class="row">
            <div class="col-12">
                <hr class="green">
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <input-field v-if="isCompany" :label="$t('auth.register.form.company')" v-model="form.company" type="text" name="company" :required="true" :errors="registerErrors"></input-field>
                <div class="row" v-if="isCompany">
                    <div class="col-lg-8 col-md-6">
                        <input-field :label="$t('auth.register.form.vatid')" v-model="form.vat_id" type="text" name="vat_id" :required="true" :errors="registerErrors"></input-field>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="form-group">
                            <label for="vat" class="control-label">{{$t('auth.register.form.vat')}} <span class="required">*</span></label>
                            <div class="row">
                                <div class="col-6">
                                    <div class="radio">
                                        <label>
                                            <input name="vat" value="1" v-model="form.vat" type="radio" />
                                            <span>{{$t('auth.register.form.yes')}}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="radio">
                                        <label>
                                            <input name="vat" value="0" v-model="form.vat" type="radio" checked />
                                            <span>{{$t('auth.register.form.no')}}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <input-field :label="$t('auth.register.form.name')" v-model="form.first_name" type="text" name="first_name" :required="true" :errors="registerErrors" :autofocus="true"></input-field>
                <input-field :label="$t('auth.register.form.lastname')" v-model="form.last_name" type="text" name="last_name" :required="true" :errors="registerErrors"></input-field>
                <input-field :label="$t('auth.register.form.email')" v-model="form.email" type="text" name="email" :required="true" :errors="registerErrors"></input-field>
                <input-field :label="$t('auth.register.form.phone')" v-model="form.phone" type="text" name="phone" :required="false" :errors="registerErrors"></input-field>
            </div>
            <div class="col-sm-6">
                <input-field :label="$t('auth.register.form.address')" v-model="form.address" type="text" name="address" :required="true" :errors="registerErrors"></input-field>
                <input-field :label="$t('auth.register.form.zip')" v-model="form.zip" type="text" name="zip" :required="true" :errors="registerErrors"></input-field>
                <input-field :label="$t('auth.register.form.city')" v-model="form.city" type="text" name="city" :required="true" :errors="registerErrors"></input-field>
                <div class="form-group">
                  <label for="country" class="control-label">{{$t('auth.register.form.country')}} <span class="required">*</span></label>
                  <select id="country" name="country" class="form-control" v-model="form.country">
                    <option v-for="coutry in $t('countries')" :key="coutry" :value="coutry">{{coutry}}</option>
                  </select>
                </div>
                <input-field v-if="normal" :label="$t('auth.register.form.password')" v-model="form.password" type="password" name="password" :required="true" :errors="registerErrors"></input-field>
                <input-field v-if="normal" :label="$t('auth.register.form.passwordRepeat')" v-model="form.password_confirmation" type="password" name="password_confirmation" :required="true" :errors="registerErrors"></input-field>
            </div>
        </div>
        <div class="row">
            <div class="col-9 col-sm-6 text-right">
                <div class="label">{{$t('cart.register.create_account')}}</div>
            </div>
            <div class="col-3 col-sm-6">
                <div class="form-group">
                    <div class="checkbox">
                        <label>
                            <input name="create" v-model="normal" type="checkbox" />
                            <span class="left"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row" key="newsletter" v-if="normal">
            <div class="col-9 col-sm-6 text-right">
                <div class="label">{{$t('auth.register.form.enews')}}</div>
            </div>
            <div class="col-3 col-sm-6">
                <div class="form-group">
                    <div class="checkbox">
                        <label>
                            <input name="news" value="1" v-model="form.news" type="checkbox" />
                            <span class="left"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12" v-html="$t('auth.register.form.gdprText')"></div>
            <div class="col-12 text-center">
              <br><br>
                <div class="form-group">
                    <div class="checkbox">
                        <label>
                            <input name="privacy" v-model="form.privacy" type="checkbox" />
                            <span class="left" v-html="$t('auth.register.form.privacy')"></span>
                        </label>
                    </div>
                    <span v-if="registerErrors.has('privacy')" class="invalid-feedback">
                        <strong>{{ registerErrors.get('privacy') }}</strong>
                    </span>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12 col-sm-3 text-center">
                <br>
                <button type="submit" class="btn btn-outline-green w-100" @click.prevent="submitRegistration">
                    {{$t('auth.reset.btn')}}
                </button>
            </div>
        </div>
    </form>
</div>
</template>

<script>
import InputField from './InputField'
import { RegistrationType, UserType } from './'
import { createNamespacedHelpers as nsHelper } from 'vuex'

const {
  mapState: mapUserState,
  mapActions: mapUserActions
} = nsHelper('user')

export default {

  components: {
    InputField
  },

  props: {
    type: {
      default: null,
      type: Number
    }
  },

  data () {
    return {
      form: null,
      userType: UserType.PERSON,
      registrationType: this.type
    }
  },

  computed: {

    ...mapUserState([
      'user',
      'loading',
      'registerErrors'
    ]),

    guest () {
      return this.registrationType === RegistrationType.GUEST
    },

    normal: {
      get () {
        return this.registrationType === RegistrationType.USER
      },
      set (val) {
        this.registrationType = val
          ? RegistrationType.USER
          : RegistrationType.GUEST
      }
    },

    isCompany () {
      return this.userType === UserType.COMPANY
    },

    personBtnClassList () {
      return {
        'btn': true,
        'w-100': true,
        'btn-outline-light': true,
        'btn-outline-medium-gray': true,
        'selected': !this.isCompany
      }
    },

    companyBtnClassList () {
      return {
        'btn': true,
        'w-100': true,
        'btn-outline-light': true,
        'btn-outline-medium-gray': true,
        'selected': this.isCompany
      }
    }

  },

  created () {
    this.form = {
      ...this.user,
      password: null,
      password_confirmation: null,
      news: false,
      sms: false,
      privacy: false
    }
  },

  methods: {
    ...mapUserActions([
      'register',
      'registerGuest'
    ]),

    submitRegistration () {
      let data = this.form

      this.guest
        ? this.registerGuest({data})
        : this.register({data})
    }
  },

  watch: {
    type: function (val) {
      this.registrationType = this.type
    }
  }
}
</script>
